import classNames from 'classnames/bind';
import {
  PriceTransparencyAdditionalServices,
  PriceTransparencyDetail,
  PriceTransparencyMileage,
} from 'types/apollo';
import RouteInfoWithLogo from './ModalContent/RouteInfoWithLogo';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface AdditionalServicesProps {
  priceTransparency: PriceTransparencyDetail[];
}

const formatMileageInfo = (mileage?: PriceTransparencyMileage | null) => {
  if (!mileage) {
    return '정보확인필요';
  }

  if (!mileage?.available) {
    return '불가능';
  }

  if (mileage.amount || mileage.rate) {
    const amountText = mileage.amount
      ? `${mileage.amount.toLocaleString()} 마일`
      : '';
    const rateText = mileage.rate ? `${mileage.rate * 100}%` : '';
    const separator = mileage.amount && mileage.rate ? ', ' : '';

    return `${amountText}${separator}${rateText} 적립`;
  }

  return '가능 (정보확인필요)';
};

const formatSeatSelectionInfo = (
  seatSelectionAvailable?: PriceTransparencyAdditionalServices['seatSelectionAvailable'],
) => {
  if (seatSelectionAvailable === undefined) {
    return '정보확인필요';
  }
  return seatSelectionAvailable ? '무료 지정 가능' : '무료 지정 불가능';
};

const formatMealInfo = (
  mealIncluded?: PriceTransparencyAdditionalServices['mealIncluded'],
) => {
  if (mealIncluded === undefined) {
    return '정보확인필요';
  }
  return mealIncluded ? '포함' : '불포함';
};

const AdditionalServices = ({ priceTransparency }: AdditionalServicesProps) => {
  return (
    <div className={cx('AdditionalServices')}>
      <div className={cx('panel')} data-type="panel">
        {priceTransparency.map(({ policy }, index) => (
          <div key={index} className={cx('section')}>
            <RouteInfoWithLogo routeIndex={index} />
            <table className={cx('table')}>
              <thead>
                <tr>
                  <th>항목</th>
                  <th>내용</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>마일리지 적립</td>
                  <td>{formatMileageInfo(policy?.mileage)}</td>
                </tr>
                <tr>
                  <td>사전 좌석 지정</td>
                  <td>
                    {formatSeatSelectionInfo(
                      policy?.additionalServices?.seatSelectionAvailable,
                    )}
                  </td>
                </tr>
                <tr>
                  <td>기내식</td>
                  <td>
                    {formatMealInfo(policy?.additionalServices?.mealIncluded)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ))}
      </div>
      <div className={cx('footnote')}>
        <p className={cx('text')}>
          본 정보는 참고용으로, 각 항목별 이용을 위한 자세한 내용은 항공권 예약
          시 여행사 홈페이지에서 확인하시길 바랍니다.
        </p>
      </div>
    </div>
  );
};

export default AdditionalServices;
